import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList/TabList'
import TabPanel from '@mui/lab/TabPanel'
import {Tab} from '@mui/material'
import Box from '@mui/material/Box'
import AwardsSearchResult from 'app/components/AwardsSearchResult'
import BusinessSearchResult from 'app/components/BusinessSearchResult'
import InnovationsSearchResult from 'app/components/InnovationsSearchResult'
import OpportunitySearchResult from 'app/components/OpportunitySearchResult'
import {PaginationSettings} from 'app/components/pagination/CustomIconPagination'
import {useGetEntityResultsByConceptV2} from 'app/hooks/graph/useGetEntityResultsByConceptV2'
import {useGetSearchByIdInvoke} from 'app/hooks/searches/useGetSearchByIdInvoke'
import {ISavedSearchFE} from 'interfaces/ISavedSearchFE'
import React from 'react'
import {useSearchParams} from 'react-router-dom'
//import ResultsHeaderActions from './ResultsHeaderActions'

// interface Props {
//   search: ISavedSearchFE
//   activeTab: string
//   setActiveTab: React.Dispatch<React.SetStateAction<string>>
// }

export default function DiscoveryViewResultsNotify(): React.ReactElement {
  const [searchParams] = useSearchParams()
  const pageParam = searchParams.get('page')
  const search_id = searchParams.get('searchId')
  const [activeTab, setActiveTab] = React.useState<string>('opportunity')
  const [search, setSearch] = React.useState<ISavedSearchFE | null>(null)
  const findSearch = useGetSearchByIdInvoke()
  //stp one, execute the search

  const conceptMap = new Map<string, number>()
  search?.concepts?.map((c) => {
    if (c.__lock !== 'exclude') conceptMap.set(c.id ?? '', c.__weight)
  })
  const oppsArgs = {
    entity: 'opportunity',
    concept_ids: Object.fromEntries(conceptMap),
    page: 1,
    perPage: PaginationSettings?.itemsPPSearch,
    filter_keywords: search?.keywords,
    algorithm: 'standard',
  }
  const opportunityResultsHook = useGetEntityResultsByConceptV2(oppsArgs)

  React.useEffect(() => {
    if (search_id) {
      findSearch.mutateAsync({search_id}).then((searchData) => {
        setSearch(searchData)
      })
    }
  }, [search_id])

  const [businessPage, setBusinessPage] = React.useState<number>(
    pageParam && activeTab === 'business' ? Number.parseInt(pageParam) : PaginationSettings.page
  )
  const [innovationPage, setInnovationPage] = React.useState<number>(
    pageParam && activeTab === 'innovation' ? Number.parseInt(pageParam) : PaginationSettings.page
  )
  const [opportunityPage, setOpportunityPage] = React.useState<number>(
    pageParam && activeTab === 'opportunity' ? Number.parseInt(pageParam) : PaginationSettings.page
  )
  const [businessPrev, setBusinessPrev] = React.useState<number>(
    pageParam && activeTab === 'business' ? Number.parseInt(pageParam) - 1 : PaginationSettings.prev
  )
  const [itemsPP, setItemsPP] = React.useState<number>(PaginationSettings.itemsPPSearch)
  const [awardPage, setAwardPage] = React.useState(
    pageParam && activeTab === 'award' ? Number.parseInt(pageParam) : PaginationSettings.page
  )
  const [awardPrev, setAwardPrev] = React.useState(
    pageParam && activeTab === 'award' ? Number.parseInt(pageParam) - 1 : PaginationSettings.prev
  )

  const handleBusinessPageChange = (e: React.ChangeEvent<unknown>, v: number) => {
    setBusinessPage(v)
  }
  const handleAwardPageChange = (e: React.ChangeEvent<unknown>, v: number) => {
    setAwardPage(v)
  }
  const handleInnovationPageChange = (e: React.ChangeEvent<unknown>, v: number) => {
    setInnovationPage(v)
  }
  const handleOpportunityPageChange = (e: React.ChangeEvent<unknown>, v: number) => {
    setOpportunityPage(v)
  }

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab && setActiveTab(newValue)
  }

  return (
    <Box display={'flex'} flexDirection={'column'}>
      <TabContext value={activeTab}>
        <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
          <TabList onChange={handleChange} textColor='inherit'>
            <Tab label='Businesses' value={'business'} />
            <Tab label='SBIR/STTR Awards' value={'award'} />
            <Tab label='Innovations' value={'innovation'} />
            <Tab label='Opportunities' value={'opportunity'} />
          </TabList>
        </Box>
        <TabPanel value={'business'}>
          <BusinessSearchResult
            results={[]}
            loading={false}
            page={businessPage}
            handlePagination={handleBusinessPageChange}
            itemsPP={itemsPP}
            prev={false}
            next={false}
            totalCount={100}
            search={''}
          />
        </TabPanel>
        <TabPanel value={'award'}>
          <AwardsSearchResult
            results={[]}
            loading={false}
            page={awardPage}
            handlePagination={handleAwardPageChange}
            itemsPP={itemsPP}
            prev={false}
            next={false}
            totalCount={100}
            search={''}
          />
        </TabPanel>
        <TabPanel value={'innovation'}>
          <InnovationsSearchResult
            results={[]}
            loading={false}
            page={innovationPage}
            handlePagination={handleInnovationPageChange}
            itemsPP={itemsPP}
            prev={false}
            next={false}
            totalCount={100}
            search={''}
          />
        </TabPanel>
        <TabPanel value={'opportunity'}>
          <OpportunitySearchResult
            results={opportunityResultsHook.data?.records ?? []}
            loading={opportunityResultsHook.isLoading}
            page={innovationPage}
            handlePagination={handleOpportunityPageChange}
            itemsPP={itemsPP}
            prev={opportunityResultsHook.data?.prev ?? false}
            next={opportunityResultsHook.data?.next ?? false}
            totalCount={opportunityResultsHook.data?.count ?? 0}
            search={''}
          />
        </TabPanel>
      </TabContext>
    </Box>
  )
}
